// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-activity-events-container .text-right {
  text-align: right;
}
.user-activity-events-container .user-activity-event-item {
  width: 100%;
}
.user-activity-events-container .user-activity-event-item .ant-space-item {
  display: flex;
}
.user-activity-events-container .user-activity-events-header .ant-col {
  align-content: center;
}
.user-activity-events-container .user-activity-event-main-container {
  display: flex;
  flex-direction: column;
}
.user-activity-events-container .ant-space-align-end {
  align-items: center;
}
.user-activity-events-container .ant-tag {
  border-radius: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/user-activity-events/styles.less"],"names":[],"mappings":"AAAA;EAEI,iBAAA;AAAJ;AAFA;EAMI,WAAA;AADJ;AALA;EAQM,aAAA;AAAN;AARA;EAcM,qBAAA;AAHN;AAXA;EAmBI,aAAA;EACA,sBAAA;AALJ;AAfA;EAwBI,mBAAA;AANJ;AAlBA;EA4BI,mBAAA;AAPJ","sourcesContent":[".user-activity-events-container {\n  .text-right {\n    text-align: right;\n  }\n\n  .user-activity-event-item {\n    width: 100%;\n    .ant-space-item {\n      display: flex;\n    }\n  }\n\n  .user-activity-events-header {\n    .ant-col {\n      align-content: center;\n    }\n  }\n\n  .user-activity-event-main-container {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .ant-space-align-end {\n    align-items: center;\n  }\n\n  .ant-tag {\n    border-radius: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
